import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Panel } from 'primereact/panel';
import { useNavigate } from 'react-router-dom';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Atividade } from '../../@types';
import { AtividadesService, PermissoesService } from '../../services';
import ActionButtons from './action-buttons';
import useAsyncFetch from '../../hooks/use-async';
import { convertAtividadesToList } from './utils';
import { defaultColumnProps } from '../utils';

const acoesField = (item: Atividade, onDelete: () => Promise<void>) => (
  <ActionButtons item={item} onDelete={onDelete} />
);

const AtividadePage = () => {
  const navigate = useNavigate();
  const permissoes = PermissoesService;

  const { data: atividades, refetch } = useAsyncFetch(
    {
      callback: async () =>
        convertAtividadesToList(await AtividadesService.list()),
      errorMessage: 'Falha ao buscar as atividades.',
      withLoader: true,
    },
    [],
  );

  return (
    <div className="container w-full gerenciador-dados-create-edit-container">
      <div className="flex flex-wrap mt-6 mx-3">
        <div className="text-3xl font-normal">Atividades</div>
        {permissoes.atividade.manage && (
          <Button
            className="button-secondary ml-auto"
            label="+ Novo"
            severity="success"
            onClick={() => navigate('create')}
          />
        )}
      </div>
      <div>
        <Panel className="mt-4 mx-3">
          <div className="col-12 m-auto px-4 py-0">
            <ConfirmDialog />

            <DataTable
              value={atividades}
              emptyMessage="Nenhuma atividade encontrada."
              paginator
              rows={15}
              className="mt-5 p-0 data-table p-datatable-striped"
            >
              <Column
                {...defaultColumnProps('left')}
                field="descricao"
                header="Descrição"
                className="col-4"
              />
              <Column
                {...defaultColumnProps('left')}
                field="abreviatura"
                header="Abreviatura"
                className="col-4"
              />
              <Column
                {...defaultColumnProps('left')}
                header="Tipo"
                field="humanizedTipo"
                className="col-4"
              />
              {permissoes.atividade.manage && (
                <Column
                  body={(item) => acoesField(item, refetch)}
                  header=" "
                  className="col-1"
                  align="right"
                />
              )}
            </DataTable>
          </div>
        </Panel>
      </div>
    </div>
  );
};
export default AtividadePage;
